import { render, staticRenderFns } from "./ProductsListViewNB.vue?vue&type=template&id=d96ea2b6&scoped=true"
import script from "./ProductsListViewNB.vue?vue&type=script&lang=js"
export * from "./ProductsListViewNB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ea2b6",
  null
  
)

export default component.exports